var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-tooltip',{attrs:{"title":_vm.title,"text":_vm.text,"color":_vm.color}},[_c('feather-icon',{attrs:{"icon":"HelpCircleIcon","svg-classes":"text-gray cursor-pointer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }